import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import {
  DropdownMenuButton as Button,
  DropdownMenuItem,
  DropdownMenuItems as Items
} from '@jetshop/ui/DropdownMenu';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import { ReactComponent as Carot } from '@jetshop/ui/svg/Carrot.svg';
import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import React from 'react';
import { FilterDropdownMenu } from './FilterDropdownMenu';
import { cx } from 'linaria';

export function ListFilters({ filters }) {
  const listFilters = filters.filter(
    filter => filter.__typename === 'ListFilter'
  );

  if (listFilters.length === 0) return null;

  return listFilters.map(filter => (
    <ErrorBoundary component={PassThrough} key={filter.id}>
      <ListFilter filter={filter} />
    </ErrorBoundary>
  ));
}

function ListFilter({ filter }) {
  const { apply, clear } = useListFilter({ filter });
  const onSelect = value => () => apply({ value });

  return (
    <FilterDropdownMenu>
      <Button>
        <span>{filter.name}</span>
        {filter.hasActiveItems ? <Check /> : <Carot className="carot" />}
      </Button>
      <Items as="ul">
        {filter.items.map(item => (
          <DropdownMenuItem
            key={item.id}
            onSelect={item.resultCount > 0 && onSelect(item.value)}
            style={
              item.resultCount === 0
                ? {
                    opacity: 0.6,
                    cursor: 'not-allowed',
                    textDecoration: 'line-through'
                  }
                : { cursor: 'pointer' }
            }
          >
            <span>{item.text}</span>
            <span>({item.resultCount})</span>
            <span className={cx('item-dot', item.isActive && 'active-item')}>
              <span>
                <Check />
              </span>
            </span>
          </DropdownMenuItem>
        ))}
        <>
          {filter.hasActiveItems && (
            <DropdownMenuItem
              onSelect={({ setIsOpen }) => {
                setIsOpen(false);
                clear();
              }}
            >
              {t('Clear filter')}
            </DropdownMenuItem>
          )}
        </>
      </Items>
    </FilterDropdownMenu>
  );
}

<li class="" tabindex="-1" role="menuitem" data-flight-dropdown-item="">
  <div>
    <span>Blå</span>
    <span>(4)</span>
  </div>
  <span class="css-1nwvx5z e14gh6fj0"></span>
</li>;
